import { useState } from "react";

export default function PasswordInput({ id, value, onChange, ...props }) {
    const [visible, setVisible] = useState(false);

    return (
        <div className="password-input-wrapper">
            <input
                id={id}
                type={visible ? "text" : "password"}
                value={value}
                onChange={onChange}
                {...props}
            />
            <button
                type="button"
                className="password-toggle"
                onClick={() => setVisible(!visible)}
                aria-label={visible ? "Hide password" : "Show password"}
                tabIndex={-1}
            >
                <svg width="18" height="18" viewBox="0 0 24 24">
                    <path d="M2 12 Q12 5 22 12" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                    <circle cx="12" cy="12" r="3.5" fill="currentColor" />
                    {!visible && (
                        <line x1="2" y1="2" x2="22" y2="22" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                    )}
                </svg>
            </button>
        </div>
    );
}
